import { render, staticRenderFns } from "./FixedPricesView.vue?vue&type=template&id=f074448e&scoped=true"
import script from "./FixedPricesView.vue?vue&type=script&lang=ts"
export * from "./FixedPricesView.vue?vue&type=script&lang=ts"
import style0 from "./FixedPricesView.vue?vue&type=style&index=0&id=f074448e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f074448e",
  null
  
)

export default component.exports